import { ApiPost, ApiGet, ApiDelete, ApiPut } from './Common.ts'
import { GetOrderEntryConnectorUrl, GetWebConnectorUrl } from '../stores/SettingsStore.ts'
import type {
  IEventHostRequest,
  IEventHostResponse,
  IEventRequestWithBeeNumber,
  IEventCreateRequest,
  IEventCreateResponse,
  IEventResponse,
  IEventListResponse,
  IEventTypeListResponse,
  IEventGuestCreateRequest,
  IEventGuestDeleteRequest,
  IEventGuestCreateResponse,
  IEventRequest,
  IEventGuestListResponse,
  IEventUpdateRequest,
  IShipNowCartSubmitResponse,
  IShipNowSubmitRequest,
  IMasterOrderSubmitRequest,
  IMasterOrderSubmitResponse,
  IEventAddressRequest,
  IEventGuestSendInvitationRequest,
  IEventGuestUpdateRequest,
  IEventGuestMakeHostRequest,
  ISfaHostPortalThemeGetListResponse,
  IHostPortalGetListResponse,
  IHostPortalDetailGetRequest,
  IHostPortalDetailGetResponse,
  IHostPortalEventGetRequest,
  IHostPortalEventGetResponse,
  IHostPortalEventCreateRequest,
  IHostPortalEventCreateResponse,
  IHostPortalEventUpdateRequest,
  IHostPortalEventUpdateResponse
} from '../types/EventTypes.ts'
import type { IAddressCreate } from '../types/CountryCultureTypes'
import type { ISendEmailRequest, ISendEmailResponse } from '../types/CommonTypes'

export async function GetEventHostList(
  request: IEventHostRequest
): Promise<IEventHostResponse> {
  const url = await GetOrderEntryConnectorUrl('EventHostGetList')
  return await ApiPost(url, request)
}

export async function GetEvent(
  request: IEventRequestWithBeeNumber
): Promise<IEventResponse> {
  const url = await GetOrderEntryConnectorUrl('EventGet')
  return await ApiPost(url, request)
}

export async function CreateEvent(
  request: IEventCreateRequest
): Promise<IEventCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('EventCreate')
  return await ApiPost(url, request)
}

export async function CreateEventGuest(
  request: IEventGuestCreateRequest
): Promise<IEventGuestCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('EventGuestCreate')
  return await ApiPost(url, request)
}

export async function DeleteEventGuest(
  request: IEventGuestDeleteRequest
){
  const url = await GetOrderEntryConnectorUrl('EventGuestDelete')
  return await ApiDelete(url, request)
}

export async function UpdateEventGuest(
  request: IEventGuestUpdateRequest
)
{
  const url = await GetOrderEntryConnectorUrl('EventGuestUpdate')
  return await ApiPost(url, request)
}

export async function SendInvitationEventGuest(
  request: IEventGuestSendInvitationRequest
){
  const url = await GetOrderEntryConnectorUrl('EventGuestSendInvitation')
  return await ApiPost(url, request)
}

export async function GetEventList(filter : unknown): Promise<IEventListResponse> {
  const url = await GetOrderEntryConnectorUrl('EventGetList')
  return await ApiGet(url, filter)
}

export async function GetEventListByHost(filter : unknown): Promise<IEventListResponse> {
  const url = await GetOrderEntryConnectorUrl('EventGetListByHost')
  return await ApiGet(url, filter)
}

export async function GetEventTypeList(): Promise<IEventTypeListResponse> {
  const url = await GetOrderEntryConnectorUrl('EventTypesGetList')
  return await ApiGet(url)
}

export async function AddressCreate(cartAddressCreate: IAddressCreate) {
  const url = await GetOrderEntryConnectorUrl('AddressCreate')
  return ApiPost(url, cartAddressCreate)
}

export async function GetEventGuests(request: IEventRequest): Promise<IEventGuestListResponse> {
  const url = await GetOrderEntryConnectorUrl('EventGuestGetList')
  return await ApiGet(url, request)
}

export async function UpdateEvent(
  request: IEventUpdateRequest
) {
  const url = await GetOrderEntryConnectorUrl('EventUpdate')
  return await ApiPost(url, request)
}

export async function DeleteEvent(request: IEventRequest) {
  const url = await GetOrderEntryConnectorUrl('EventDelete')
  return await ApiDelete(url, request)
}

export async function GetEventMasterOrder(request: IEventRequest) {
  const url = await GetOrderEntryConnectorUrl('EventMasterOrderGet')
  return await ApiGet(url, request)
}

export async function ShipNowCartSubmit(
  request: IShipNowSubmitRequest
): Promise<IShipNowCartSubmitResponse> {
  const url = await GetOrderEntryConnectorUrl('ShipNowCartSubmit')
  return ApiPost(url, request)
}

export async function MasterOrderSubmit(
  request: IMasterOrderSubmitRequest
): Promise<IMasterOrderSubmitResponse> {
  const url = await GetOrderEntryConnectorUrl('MasterOrderSubmit')
  return ApiPost(url, request)
}

export async function EventAddressCreate(
  request: IEventAddressRequest
) {
  const url = await GetOrderEntryConnectorUrl('EventAddressCreate')
  return ApiPut(url, request)
}

export async function MakeHostEventGuest(
  request: IEventGuestMakeHostRequest
){
  const url = await GetOrderEntryConnectorUrl('EventGuestMakeHost')
  return await ApiPost(url, request)
}

export async function HostPortalThemeGetList(): Promise<ISfaHostPortalThemeGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalThemeGetList')
  return ApiGet(url)
}

export async function HostPortalGetList(): Promise<IHostPortalGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalGetList')
  return ApiGet(url)
}

export async function HostPortalDetailGet(request: IHostPortalDetailGetRequest): Promise<IHostPortalDetailGetResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalDetailGet')
  return ApiPost(url, request)
}

export async function HostPortalEventGet(request: IHostPortalEventGetRequest): Promise<IHostPortalEventGetResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalEventGet')
  return ApiGet(url, request)
}

export async function HostPortalEventCreate(request: IHostPortalEventCreateRequest): Promise<IHostPortalEventCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalEventCreate')
  return ApiPost(url, request)
}

export async function HostPortalEventUpdate(request: IHostPortalEventUpdateRequest): Promise<IHostPortalEventUpdateResponse> {
  const url = await GetOrderEntryConnectorUrl('HostPortalEventUpdate')
  return ApiPost(url, request)
}

export async function SendEmail(request: ISendEmailRequest): Promise<ISendEmailResponse> {
  const url = await GetWebConnectorUrl('PwsSendEmail')
  return ApiPost(url, request)
}
